import { Group, Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface InfoRowProps {
  label: string;
  value: string | ReactNode;
}

/**
 * Simple info row component for displaying label-value pairs
 */
export function InfoRow({ label, value }: InfoRowProps): JSX.Element {
  return (
    <Group justify="space-between" py="xs">
      <Text size="sm" c="gray.6">
        {label}
      </Text>
      <Text size="sm" fw={500}>
        {value || '--'}
      </Text>
    </Group>
  );
}
